import { render, staticRenderFns } from "./ProfileOnboardingVideo.vue?vue&type=template&id=275e0f2c"
import script from "./ProfileOnboardingVideo.vue?vue&type=script&lang=js"
export * from "./ProfileOnboardingVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports